module.exports = __webpack_public_path__ + "static/img/pj1-2.5aa8a10.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/pj1-2.png
// module id = 711
// module chunks = 0